import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import {
  CREZCO_DONATION_APP_CONFIG,
  CrezcoDonationAppRuntimeConfig,
} from 'src/app/app.config';
import {
  Donation,
  ApiDonation,
  adaptDonation,
} from '../../types/donations-feed/models';

@Injectable({ providedIn: 'root' })
export class DonationsService {
  constructor(
    private http: HttpClient,
    @Inject(CREZCO_DONATION_APP_CONFIG)
    private config: CrezcoDonationAppRuntimeConfig
  ) {}

  private get endpoint(): string {
    // En tus screenshots es /api/donations (minúsculas)
    return `${this.config.apiBaseUrl}/donations`;
  }

  list(): Observable<Donation[]> {
    return this.http
      .get<ApiDonation[]>(this.endpoint)
      .pipe(map((list) => (list ?? []).map(adaptDonation)));
  }

  like(id: string, liked: boolean): Observable<{ likes: number }> {
    return this.http.post<{ likes: number }>(`${this.endpoint}/${id}/like`, {
      liked,
    });
  }
}
